import ControlInput from 'lqa-ui/lib/Components/ControlInput';
import React, { useState } from 'react';
import profile from '../../../www/assets/gif/profile.gif';
import styled from 'styled-components';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import RegisterStepper from '../../components/RegisterStepper';
import { useLocation, useNavigate } from 'react-router-dom';
import { linkMembershipByToken } from './apicaller';
import { showErrorMessage } from '../../helpers/showMessage';
import { NotLoggedInHeader } from './../../app/common/sharedComponents/NotLoggedInHeader';
import { PASSWORD_REGEX, EMAIL_REGEX } from '../../utils/regex';

const ImageBackgroundContainer = styled('div')`
  background: #d9d9d9;
  border-radius: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 20px 18px;
  margin: 0 15px;
  height: 402px;
`;
const LoginContainer = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #fff;
  row-gap: 1rem;
  margin-bottom: 50px;
`;
const StepsNumber = styled('div')`
  color: #1f1f1f;
  text-align: center;
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 129.412% */
  margin-top: 13px;
  padding-bottom: 13px;
`;
const HeaderSection = styled('div')`
  width: 100%;
  margin-bottom: 1rem;
`;

const Divider = styled('div')`
  margin: 0 -1rem;
`;
const TopSection = styled('div')`
  position: fixed;
  background: white;
  width: 100%;
  z-index: 99;
`;

const ButtonContainer = styled.div`
  margin: 0 15px;
`;

const signIn = () => {
  const location = useLocation();
  const loc: any = { ...location };
  const { accessToken } = loc.state;
  const [form, setForm] = useState({
    email: '',
    userPassword: '',
  });
  const navigate = useNavigate();
  const registerHandler = () => {
    navigate(-1);
  };

  const linkMembershipHandler = () => {
    if (
      form.email === '' ||
      !EMAIL_REGEX.test(form.email) ||
      form.userPassword === '' ||
      form.userPassword.length < 7 ||
      !PASSWORD_REGEX.test(form.userPassword)
    ) {
      showErrorMessage('Please fill all data');
      return;
    }
    const payLoad = {
      password: form.userPassword,
      username: form.email.trim().toLowerCase(),
    };
    linkMembershipByToken(accessToken, payLoad)
      .then((res) => (window.location.href = `/register-success/register`))
      .catch((err) => showErrorMessage('No Membership Detail Found'));
  };
  return (
    <LoginContainer>
      <TopSection>
        <NotLoggedInHeader
          isRegistering={true}
          step={3}
        />

        <StepsNumber>Step 3 of 3</StepsNumber>

        <HeaderSection>
          <RegisterStepper step={3} isDeactivatedUser={false} />
        </HeaderSection>
        <Divider className="d-block black-border-1" />
      </TopSection>
      <h3
        className="fw-600 f-24 lh-24 sans-font font-normal color-071C3E "
        style={{ padding: '0 1rem 0 1rem', marginTop: '225px' }}
      >
        Create Your{' '}
        <span
          style={{
            fontStyle: 'italic',
          }}
        >
          my
        </span>
        LQA Profile
      </h3>
      <ImageBackgroundContainer>
        <img src={profile} className="w-100 mb-20" />
        <div className="text-left mt-20 d-flex flex-direction-column gap-15 w-100">
          <div>
            <span className="fw-400 f-15 lh-22 color-717171 mb-10">
              myLQA Membership Email
            </span>
            <ControlInput
              name="email"
              label="Email Address"
              value={form.email}
              onChange={(e) => {
                setForm({ ...form, email: e.target.value });
              }}
              required={true}
              hasError={false}
              disabled={false}
              style={{
                textAlign: 'left',
              }}
              type="email"
            />
          </div>
          <div className="mb-10">
            <span className="fw-400 f-15 lh-22 color-717171 mb-10">
              Password
            </span>
            <ControlInput
              label="Password"
              name="password"
              value={form.userPassword}
              onChange={(e) => {
                setForm({ ...form, userPassword: e.target.value });
              }}
              required={true}
              hasError={false}
              disabled={false}
              secureTextEntry={true}
              style={{
                textAlign: 'left',
              }}
            />
          </div>
        </div>
      </ImageBackgroundContainer>
      <ButtonContainer>
        <ButtonLarge
          title="Link myLQA Membership"
          onClick={() => {
            linkMembershipHandler();
          }}
          backgroundColor="oxfordBlue"
        />
      </ButtonContainer>
      <div className=" m-0-auto">
        <span className="fw-400 f-15 lh-20 color-979797">
          Don't have an account?
          <span
            className="fw-bold sans-font font-normal color-4FADA6 fw-700"
            onClick={registerHandler}
          >
            Register
          </span>
        </span>
      </div>
    </LoginContainer>
  );
};

export default signIn;
